import PersonalForm from "../components/PersonalForm";
import BusinessForm from "../components/BusinessForm";
import FinanceForm from "../components/FinanceForm";
import CreditForm from "../components/CreditForm.jsx";
import IncomeForm from "../components/IncomeForm";
import SupportingForm from "../components/SupportingForm";

export const services = [
    { label: "Business Solutions", value: "business", forms: ["businessForm"] },
    { label: "Personal Finance - Budgeting & Debt Solutions", value: "budgeting", forms: ["incomeForm", "financeForm",  "supportingForm"] },
    { label: "Personal Finance - Credit Programs", value: "credit", forms: ["personalForm", "creditForm", "incomeForm", "supportingForm"] },
    { label: "Personal Finance - Net Worth, Savings, Will & Trust", value: "netWorth", forms: ["incomeForm", "financeForm"] },
    //{ label: "YFL Family Mint", value: "familyMint", forms: ["contactForm"] },
    //{ label: "Other", value: "other", forms: ["contactForm"] },
];

export const formComponents = {
    personalForm: PersonalForm,
    businessForm: BusinessForm,
    financeForm: FinanceForm,
    creditForm: CreditForm,
    incomeForm: IncomeForm,
    supportingForm: SupportingForm,
};
